import dJSON from 'dirty-json';

const moduleSelector = '.who-we-serve';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.querySelector('.grid-wrapper').insertAdjacentHTML('beforeend', /* html */ `
          <a href="${item.button_link}" class="grid-item">
            <div class="image-wrapper">
              <img src="${item.background}" alt="">
            </div>
            <div class="content-wrapper">
              <h3 class="title">${item.title || ''}</h3>
              <p class="details">${item.details || ''}</p>
              ${item.button_text ? `<button class="btn-custom primary">${item.button_text}</button>` : ''}
            </div>
          </a>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
